import React from 'react';

// Mảng chứa thông tin cấu hình cho mỗi tia sáng
// Bạn có thể dễ dàng thêm/bớt hoặc thay đổi các tia sáng ở đây
const lightBeams = [
  // Cụm bên trái
  { position: 'left-0', rotation: 'rotate-[15deg]', size: 'w-72 h-[500px]', opacity: 'opacity-30' },
  { position: 'left-[10%]', rotation: 'rotate-[25deg]', size: 'w-64 h-[550px]', opacity: 'opacity-20' },
  { position: 'left-[20%]', rotation: 'rotate-[35deg]', size: 'w-56 h-[500px]', opacity: 'opacity-30' },
  // Cụm bên phải
  { position: 'right-0', rotation: '-rotate-[15deg]', size: 'w-72 h-[500px]', opacity: 'opacity-30' },
  { position: 'right-[10%]', rotation: '-rotate-[25deg]', size: 'w-64 h-[550px]', opacity: 'opacity-20' },
  { position: 'right-[20%]', rotation: '-rotate-[35deg]', size: 'w-56 h-[500px]', opacity: 'opacity-30' },
  // Tia ở giữa
  { position: 'left-1/2 -translate-x-1/2', rotation: 'rotate-[0deg]', size: 'w-80 h-[550px]', opacity: 'opacity-25' },
];

export const StageLights = () => {
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 z-0 overflow-hidden">
      <div className="absolute bottom-0 left-0 right-0 top-0 bg-[radial-gradient(circle_1000px_at_50%_200px,#1e90ff,transparent)]" />
      {lightBeams.map((beam, index) => (
        <div
          key={index}
          className={`absolute top-0 origin-top transform-gpu ${beam.position} ${beam.rotation} ${beam.size} ${beam.opacity}`}
          style={{
            // Tạo hình dạng tia sáng (hình thang)
            clipPath: 'polygon(30% 0, 70% 0, 100% 100%, 0% 100%)',
            // Tạo màu sắc chuyển từ sáng sang trong suốt
            background: 'linear-gradient(to bottom, rgba(173, 216, 230, 0.6), transparent)',
            // Làm mờ để tạo hiệu ứng glow
            filter: 'blur(30px)',
          }}
        />
      ))}
    </div>
  );
};
